import React from "react";
import { useTranslation } from "react-i18next";
import { SubPage, FullDivider } from "./SubPage";

const VALID = new Set(["consulting", "design", "engineering"]);

export function ServicePage({ slug }: { slug: string }) {
  const { t } = useTranslation("services");
  if (!VALID.has(slug)) return null;
  const title = t(`${slug}.title`);
  const subtitle = t(`${slug}.subtitle`);
  const sections = t(`${slug}.sections`, { returnObjects: true }) as { heading: string; body: string }[];

  return (
    <SubPage title={title} subtitle={subtitle}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-grey-800">
        {sections.map((s) => (
          <div key={s.heading} className="bg-grey-975 px-5 sm:px-8 md:px-[66px] py-10 md:py-12">
            <h3 className="text-base font-semibold text-white mb-3">{s.heading}</h3>
            <p className="text-sm text-grey-400 leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>
      <FullDivider />
    </SubPage>
  );
}
